module.exports = __webpack_public_path__ + "4640125ef27ff1350c60c4fbf20da520.pdf";